import React, { useState } from "react";

const LearningPathTFD = () => {
  const [toggleAllSections, setToggleAllSections] = useState(false);
  const [sectionToggle, setSectionToggle] = useState({});
  const [toggleNewModule, setToggleNewModule] = useState(false);
  const [newModuleToggle, setNewModuleToggle] = useState({});
  const [toggleExteraModule, setToggleExteraModule] = useState(false);
  const [exteraModuleToggle, setExteraModuleToggle] = useState({});
  const [toggleIsExteraModule, setToggleIsExteraModule] = useState(false);
  const [isExteraModuleToggle, setIsExteraModuleToggle] = useState({});
  const [toggleAdditionalModule, setToggleAdditionalModule] = useState(false);
  const [additionalModuleToggle, setAdditionalModuleToggle] = useState({});
  const [toggleExtraAdvancedModule, setToggleExtraAdvancedModule] = useState(false);
  const [extraAdvancedModuleToggle, setExtraAdvancedModuleToggle] = useState({});
  const [toggleAndLocalModule, setToggleAndLocalModule]= useState(false);
  const [AndLocalModuleToggle, setAndLocalModuleToggle]= useState({});
  const [toggleAndUlteraLocalModule, setToggleAndUlteraLocalModule]= useState(false);
  const [AndUlteraLocalModuleToggle, setAndUlteraLocalModuleToggle]= useState({});
  
  const listContent = [
    // HTML Fundamentals
    {
      id: 1,
      title: "Introduction to HTML",
      nestedContent: [
        { id: 1, text: "• What is HTML? History and evolution of HTML.", dummyText: [] },
        { id: 2, text: "• Structure of an HTML document (DOCTYPE, html, head, body).", dummyText: [] },
        { id: 3, text: "• Setting up code editor (VS Code, Sublime Text, Atom).", dummyText: [] },
      ],
    },
    {
      id: 2,
      title: "HTML Elements and Tags",
      nestedContent: [
        { id: 1, text: "• Heading tags (h1 to h6) and paragraph tags.", dummyText: [] },
        { id: 2, text: "• Lists: Ordered lists (ol), Unordered lists (ul), Description lists (dl).", dummyText: [] },
        { id: 3, text: "• Links and navigation using anchor tags.", dummyText: [] },
      ],
    },
    {
        id: 3,
        title: "HTML Forms and Input Elements",
        nestedContent: [
          { id: 1, text: "• Creating forms with form tags.", dummyText: [] },
          { id: 2, text: "• Input types: text, password, email, number, date, file.", dummyText: [] },
          { id: 3, text: "• Select dropdowns, textareas, and buttons.", dummyText: [] },
          { id: 4, text: "• Form validation using HTML5 attributes.", dummyText: [] },
        ],
      },
      {
        id: 4,
        title: "HTML Tables and Multimedia",
        nestedContent: [
          { id: 1, text: "• Creating tables with table, tr, th, td tags.", dummyText: [] },
          { id: 2, text: "• Spanning rows and columns (rowspan, colspan).", dummyText: [] },
          { id: 3, text: "• Embedding images with img tag.", dummyText: [] },
          { id: 4, text: "• Adding audio and video using audio and video tags.", dummyText: [] },
        ],
      },
  ];

  const newModuleContent = [
    // CSS Fundamentals
    {
      id: 1,
      title: "Introduction to CSS",
      nestedContent: [
        { id: 1, text: "• What is CSS? Inline, Internal, and External CSS.", dummyText: [] },
        { id: 2, text: "• CSS syntax: Selectors, properties, and values.", dummyText: [] },
        { id: 3, text: "• Basic selectors: element, class, and ID selectors.", dummyText: [] },
      ],
    },
    {
      id: 2,
      title: "CSS Box Model and Layout",
      nestedContent: [
        { id: 1, text: "• Understanding the box model (margin, border, padding, content).", dummyText: [] },
        { id: 2, text: "• CSS positioning: static, relative, absolute, fixed, sticky.", dummyText: [] },
        { id: 3, text: "• Display properties: block, inline, inline-block, none.", dummyText: [] },
      ],
    },
    {
        id: 3,
        title: "CSS Flexbox",
        nestedContent: [
          { id: 1, text: "• Introduction to Flexbox and its properties.", dummyText: [] },
          { id: 2, text: "• Flex container properties: flex-direction, justify-content, align-items.", dummyText: [] },
          { id: 3, text: "• Flex item properties: order, flex-grow, flex-shrink.", dummyText: [] },
          { id: 4, text: "• Building responsive layouts with Flexbox.", dummyText: [] },
        ],
      },
      {
        id: 4,
        title: "CSS Grid",
        nestedContent: [
          { id: 1, text: "• Introduction to CSS Grid Layout.", dummyText: [] },
          { id: 2, text: "• Grid container properties: display: grid, grid-template-columns, grid-gap.", dummyText: [] },
          { id: 3, text: "• Grid item properties: grid-column, grid-row.", dummyText: [] },
        ],
      },
      {
        id: 5,
        title: "CSS Colors, Typography, and Effects",
        nestedContent: [
          { id: 1, text: "• Color formats: HEX, RGB, RGBA, HSL, HSLA.", dummyText: [] },
          { id: 2, text: "• Font properties: font-family, font-size, font-weight.", dummyText: [] },
          { id: 3, text: "• Text styling: text-align, text-decoration, line-height.", dummyText: [] },
          { id: 4, text: "• Shadows, gradients, and transitions.", dummyText: [] },
        ],
      },
      {
        id: 6,
        title: "Responsive Web Design",
        nestedContent: [
          { id: 1, text: "• Media queries and breakpoints.", dummyText: [] },
          { id: 2, text: "• Mobile-first design approach.", dummyText: [] },
          { id: 3, text: "• Building responsive navigation bars.", dummyText: [] },
          { id: 4, text: "• Practical Exercises: Creating responsive layouts.", dummyText: [] },
        ],
      },
  ];

  const exteraModuleContent = [
    // JavaScript Fundamentals
    {
      id: 1,
      title: "Introduction to JavaScript",
      nestedContent: [
        { id: 1, text: "• What is JavaScript? History and features.", dummyText: [] },
        { id: 2, text: "• Adding JavaScript to HTML (inline, internal, external).", dummyText: [] },
        { id: 3, text: "• JavaScript console and debugging.", dummyText: [] },
      ],
    },
    {
      id: 2,
      title: "JavaScript Variables and Data Types",
      nestedContent: [
        { id: 1, text: "• Declaring variables: var, let, const.", dummyText: [] },
        { id: 2, text: "• Data types: string, number, boolean, null, undefined, symbol.", dummyText: [] },
        { id: 3, text: "• Type conversion and type coercion.", dummyText: [] },
      ],
    },
    {
        id: 3,
        title: "Operators and Expressions",
        nestedContent: [
          { id: 1, text: "• Arithmetic operators (+, -, *, /, %).", dummyText: [] },
          { id: 2, text: "• Comparison operators (==, ===, !=, !==, >, <).", dummyText: [] },
          { id: 3, text: "• Logical operators (&&, ||, !).", dummyText: [] },
          { id: 4, text: "• Ternary operator and operator precedence.", dummyText: [] },
        ],
      },
      {
        id: 4,
        title: "Control Flow Statements",
        nestedContent: [
          { id: 1, text: "• Conditional statements: if, else if, else, switch.", dummyText: [] },
          { id: 2, text: "• Loops: for, while, do-while, for...in, for...of.", dummyText: [] },
          { id: 3, text: "• Break and continue statements.", dummyText: [] },
        ],
      },
  ];

  const additionalModuleContent = [
    // JavaScript Functions and Arrays
    {
      id: 1,
      title: "JavaScript Functions",
      nestedContent: [
        { id: 1, text: "• Function declarations and expressions.", dummyText: [] },
        { id: 2, text: "• Arrow functions (ES6).", dummyText: [] },
        { id: 3, text: "• Parameters and arguments, default parameters.", dummyText: [] },
        { id: 4, text: "• Return statements and function scope.", dummyText: [] },
      ],
    },
    {
      id: 2,
      title: "Arrays and Array Methods",
      nestedContent: [
        { id: 1, text: "• Creating and manipulating arrays.", dummyText: [] },
        { id: 2, text: "• Array methods: push, pop, shift, unshift, splice.", dummyText: [] },
        { id: 3, text: "• Iteration methods: forEach, map, filter, reduce.", dummyText: [] },
        { id: 4, text: "• Finding elements: find, findIndex, includes.", dummyText: [] },
      ],
    },
    {
        id: 3,
        title: "Objects and JSON",
        nestedContent: [
          { id: 1, text: "• Creating and accessing object properties.", dummyText: [] },
          { id: 2, text: "• Object methods and 'this' keyword.", dummyText: [] },
          { id: 3, text: "• JSON.stringify() and JSON.parse().", dummyText: [] },
          { id: 4, text: "• Object destructuring and spread operator.", dummyText: [] },
        ],
      },
      {
        id: 4,
        title: "Practical Exercises",
        nestedContent: [
          { id: 1, text: "• Building interactive web pages with JavaScript.", dummyText: [] },
        ],
      },
  ];

  const isExteraModuleContent = [
    // DOM Manipulation and Events
    {
      id: 1,
      title: "DOM Manipulation",
      nestedContent: [
        { id: 1, text: "• Selecting DOM elements: getElementById, querySelector, querySelectorAll.", dummyText: [] },
        { id: 2, text: "• Manipulating element content: innerHTML, textContent, innerText.", dummyText: [] },
        { id: 3, text: "• Modifying attributes and classes: setAttribute, classList.", dummyText: [] },
        { id: 4, text: "• Creating, appending, and removing elements.", dummyText: [] },
      ],
    },
    {
      id: 2,
      title: "Event Handling",
      nestedContent: [
        { id: 1, text: "• Understanding events and event listeners.", dummyText: [] },
        { id: 2, text: "• Mouse events: click, dblclick, mouseover, mouseout.", dummyText: [] },
        { id: 3, text: "• Keyboard events: keydown, keyup, keypress.", dummyText: [] },
        { id: 4, text: "• Form events: submit, change, focus, blur.", dummyText: [] },
        { id: 5, text: "• Event delegation and event object.", dummyText: [] },
      ],
    },
    {
        id: 3,
        title: "Browser Storage",
        nestedContent: [
          { id: 1, text: "• LocalStorage and SessionStorage.", dummyText: [] },
          { id: 2, text: "• Cookies: setting, getting, and deleting cookies.", dummyText: [] },
          { id: 3, text: "• IndexedDB for large data storage.", dummyText: [] },
        ],
      },
      {
        id: 4,
        title: "Practical Exercises",
        nestedContent: [
          { id: 1, text: "• Building interactive forms and dynamic content.", dummyText: [] },
          { id: 2, text: "• Creating to-do list application.", dummyText: [] },
        ],
      },
  ];

  const extraAdvancedModuleContent = [
    // Advanced JavaScript (ES6+)
    {
      id: 1,
      title: "ES6+ Features",
      nestedContent: [
        { id: 1, text: "• Template literals and string interpolation.", dummyText: [] },
        { id: 2, text: "• Destructuring arrays and objects.", dummyText: [] },
        { id: 3, text: "• Spread and rest operators.", dummyText: [] },
        { id: 4, text: "• Promises and async/await.", dummyText: [] },
      ],
    },
    {
      id: 2,
      title: "Error Handling and Debugging",
      nestedContent: [
        { id: 1, text: "• Try-catch-finally blocks.", dummyText: [] },
        { id: 2, text: "• Throwing custom errors.", dummyText: [] },
        { id: 3, text: "• Debugging with Chrome DevTools.", dummyText: [] },
      ],
    },
    {
      id: 3,
      title: "Modules and Import/Export",
      nestedContent: [
        { id: 1, text: "• ES6 modules: export and import statements.", dummyText: [] },
        { id: 2, text: "• Default exports vs named exports.", dummyText: [] },
        { id: 3, text: "• Dynamic imports and code splitting.", dummyText: [] },
      ],
    },
    {
        id: 4,
        title: "Practical Exercises",
        nestedContent: [
          { id: 1, text: "• Building a weather app using APIs.", dummyText: [] },
        ],
      },
  ];

  const andLocalModuleContent = [
    // Asynchronous JavaScript
    {
      id: 1,
      title: "Callbacks and Callback Hell",
      nestedContent: [
        { id: 1, text: "• Understanding synchronous vs asynchronous code.", dummyText: [] },
        { id: 2, text: "• Callback functions and callback hell.", dummyText: [] },
        { id: 3, text: "• Solutions to callback hell.", dummyText: [] },
      ],
    },
    {
      id: 2,
      title: "Promises",
      nestedContent: [
        { id: 1, text: "• Creating and consuming promises.", dummyText: [] },
        { id: 2, text: "• Promise chaining and error handling.", dummyText: [] },
        { id: 3, text: "• Promise.all, Promise.race, Promise.allSettled.", dummyText: [] },
      ],
    },
    {
      id: 3,
      title: "Async/Await",
      nestedContent: [
        { id: 1, text: "• Async functions and await keyword.", dummyText: [] },
        { id: 2, text: "• Error handling with try-catch.", dummyText: [] },
        { id: 3, text: "• Fetching data from APIs.", dummyText: [] },
      ],
    },
    {
      id: 4,
      title: "AJAX and Fetch API",
      nestedContent: [
        { id: 1, text: "• Understanding AJAX and XMLHttpRequest.", dummyText: [] },
        { id: 2, text: "• Fetch API for network requests.", dummyText: [] },
        { id: 3, text: "• Working with REST APIs.", dummyText: [] },
      ],
    },
    {
      id: 5,
      title: "Practical Exercises",
      nestedContent: [
        { id: 1, text: "• Building a GitHub profile finder.", dummyText: [] },
        { id: 2, text: "• Creating a real-time search application.", dummyText: [] },
      ],
    },
  ];
  
  const andUlteraLocalModuleContent = [
    // Projects and Deployment
    {
      id: 1,
      title: "Project 1: Portfolio Website",
      nestedContent: [
        { id: 1, text: "• Designing a responsive personal portfolio.", dummyText: [] },
        { id: 2, text: "• Implementing smooth scrolling and navigation.", dummyText: [] },
        { id: 3, text: "• Adding animations and hover effects.", dummyText: [] },
      ],
    },
    {
      id: 2,
      title: "Project 2: E-commerce Product Page",
      nestedContent: [
        { id: 1, text: "• Building product cards and grid layout.", dummyText: [] },
        { id: 2, text: "• Adding to cart functionality.", dummyText: [] },
        { id: 3, text: "• Implementing quantity selectors.", dummyText: [] },
      ],
    },
    {
        id: 3,
        title: "Project 3: Quiz Application",
        nestedContent: [
          { id: 1, text: "• Building interactive quiz with multiple questions.", dummyText: [] },
          { id: 2, text: "• Score calculation and result display.", dummyText: [] },
          { id: 3, text: "• Timer implementation.", dummyText: [] },
        ],
      },
    {
      id: 4,
      title: "Version Control with Git",
      nestedContent: [
        { id: 1, text: "• Git basics: init, add, commit, push, pull.", dummyText: [] },
        { id: 2, text: "• Branching and merging.", dummyText: [] },
        { id: 3, text: "• Collaborating with GitHub.", dummyText: [] },
      ],
    },
    {
        id: 5,
        title: "Deployment and Hosting",
        nestedContent: [
          { id: 1, text: "• Deploying websites using GitHub Pages.", dummyText: [] },
          { id: 2, text: "• Hosting on Netlify and Vercel.", dummyText: [] },
          { id: 3, text: "• Custom domain setup.", dummyText: [] },
        ],
      },
    {
        id: 6,
        title: "Final Capstone Project",
        nestedContent: [
          { id: 1, text: "• Planning and designing a complete website.", dummyText: [] },
          { id: 2, text: "• Implementing responsive design.", dummyText: [] },
          { id: 3, text: "• Adding interactivity with JavaScript.", dummyText: [] },
          { id: 4, text: "• Testing across different browsers.", dummyText: [] },
          { id: 5, text: "• Deploying the final project.", dummyText: [] },
          { id: 6, text: "• Project presentation and code review.", dummyText: [] },
        ],
      },
  ];

  const toggleSection = (id, module = "existing") => {
    if (module === "existing") {
      setSectionToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "new") {
      setNewModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "extera") {
      setExteraModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "isextera") {
      setIsExteraModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "additional") {
      setAdditionalModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "extraAdvanced") {
      setExtraAdvancedModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    }else if (module === "andLocal"){
        setAndLocalModuleToggle((prev) => ({...prev,[id]: !prev[id]}));
   } else if (module === "andUlteraLocal"){
    setAndUlteraLocalModuleToggle((prev) => ({...prev,[id]: !prev[id]}));
  }
  };
  
  return (
    <div className="container my-5">
      <h2 className="fw-bold mb-4" style={{ color: "#000", fontFamily: "Roboto", textAlign: "center",marginTop:'-49px', }}>
        PROGRAM <span style={{ color: "rgb(251 145 0)" }}>OVERVIEW</span>
      </h2>
      <br />
      
      {/* HTML Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleAllSections(!toggleAllSections)}
      >
        HTML Fundamentals
      </div>

      {toggleAllSections && (
        <div className="list-tab mt-3">
          {listContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id)}
              >
                {title}
                <span>{sectionToggle[id] ? "-" : "+"}</span>
              </div>
              {sectionToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* CSS Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleNewModule(!toggleNewModule)}
      >
        CSS (Cascading Style Sheets)
      </div>

      {toggleNewModule && (
        <div className="list-tab mt-3">
          {newModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "new")}
              >
                {title}
                <span>{newModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {newModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* JavaScript Fundamentals Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleExteraModule(!toggleExteraModule)}
      >
        JavaScript Fundamentals
      </div>

      {toggleExteraModule && (
        <div className="list-tab mt-3">
          {exteraModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "extera")}
              >
                {title}
                <span>{exteraModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {exteraModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* JavaScript Functions and Arrays Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleAdditionalModule(!toggleAdditionalModule)}
      >
        JavaScript Functions & Data Structures
      </div>

      {toggleAdditionalModule && (
        <div className="list-tab mt-3">
          {additionalModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "additional")}
              >
                {title}
                <span>{additionalModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {additionalModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* DOM Manipulation Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleIsExteraModule(!toggleIsExteraModule)}
      >
        DOM Manipulation & Events
      </div>

      {toggleIsExteraModule && (
        <div className="list-tab mt-3">
          {isExteraModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "isextera")}
              >
                {title}
                <span>{isExteraModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {isExteraModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
      
      {/* Advanced JavaScript Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleExtraAdvancedModule(!toggleExtraAdvancedModule)}
      >
        Advanced JavaScript (ES6+)
      </div>

      {toggleExtraAdvancedModule && (
        <div className="list-tab mt-3">
          {extraAdvancedModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "extraAdvanced")}
              >
                {title}
                <span>{extraAdvancedModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {extraAdvancedModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
      
      {/* Asynchronous JavaScript Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleAndLocalModule(!toggleAndLocalModule)}
      >
        Asynchronous JavaScript (AJAX, Promises, Async/Await)
      </div>

      {toggleAndLocalModule && (
        <div className="list-tab mt-3">
          {andLocalModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "andLocal")}
              >
                {title}
                <span>{AndLocalModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {AndLocalModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
      
      {/* Projects and Deployment Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleAndUlteraLocalModule(!toggleAndUlteraLocalModule)}
      >
        Projects & Deployment
      </div>

      {toggleAndUlteraLocalModule && (
        <div className="list-tab mt-3">
          {andUlteraLocalModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "andUlteraLocal")}
              >
                {title}
                <span>{AndUlteraLocalModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {AndUlteraLocalModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LearningPathTFD;